import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_dashboard/layout/core'
import { HeaderListWrapper } from './HeaderComponent'
import { useIntl } from 'react-intl'

const HeaderPage = () => {
  const intl = useIntl()

  const HeaderBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'HEADER_PAGE.BREADCRUMB' }),
      path: '/apps/header-management/header',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='Header'
          element={
            <>
              <PageTitle breadcrumbs={HeaderBreadcrumbs}>
                {intl.formatMessage({ id: 'HEADER_PAGE.TITLE' })}
              </PageTitle>
              <HeaderListWrapper/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/Header-management/header' />} />
    </Routes>
  )
}

export default HeaderPage
